<template lang="pug">
.container.page-not-found
  h2.ui.center.aligned.icon.header
    i.rocket.icon
    .content 未能找到请求页面
  router-link.themed.text(:to='url') 返回
</template>

<script>
export default {
  name: 'page-not-found',
  props: {
    url: { type: String, default: '/' },
  },
}
</script>



// WEBPACK FOOTER //
// PageNotFound.vue?4b0f53a1